<template>
  <div v-if="showButton">
    <b-modal id="widgety-trip-info-modal" ref="jet2-trip-info-modal-ref" hide-footer>
      <div v-if="!item.videoCover">
        <h3 class="mt-3">
          {{ cruiseData.ship && cruiseData.ship.title !== 'Not Supplied' ? cruiseData.ship.title : '' }}
        </h3>
      </div>
      <div v-if="item.videoCover && item.videoCover['750x750']" class="modal-banner-container">
        <img :src="item.videoCover['750x750']" class="vtd-center-image" />
        <div class="modal-banner-text">
          {{ cruiseData.ship && cruiseData.ship.title !== 'Not Supplied' ? cruiseData.ship.title : '' }}
        </div>
      </div>
      <span v-if="cruiseData && cruiseData.itinerary.length && cruiseData.itinerary !== 'no cruise found'">
        <div v-for="(item, index) in cruiseData.itinerary" :key="index">
          <h4 class="mt-3 orange">{{ item.day === cruiseData?.itinerary[index-1]?.day ? ' ' : 'Day ' + item.day }}</h4>
          <h6 v-if="item.port && item.port.name" class="text-left">
            {{ item.port.name }}<span v-if="item.port.country">, {{ item.port.country }}</span>
          </h6>
          <p v-if="item.name" class="text-left">
            {{ item.name }}
          </p>
          <p v-if="item.arrives_on && item.showArr !== false" class="text-left">
            Arrives {{ formatDates(item.arrives_on) }}
          </p>
          <p v-if="item.departs_on && item.showDep !== false" class="text-left">
            Departs {{ formatDates(item.departs_on) }}
          </p>
          <p v-if="item.port && item.port.summary" class="text-left" v-html="item.port.summary"/>
        </div>
      </span>
      <div
        v-else-if="item.p4text && item.p4text[0] && item.showP4notes && !item.showP4notes === false"
        class="extra-info-notes">
        <ul>
          <li v-for="(note, index) in item.p4text" :key="index" v-html="note" />
        </ul>
      </div>
    </b-modal>
    <button class="extra-info" @click="$refs['jet2-trip-info-modal-ref'].show()">
      <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Itinerary Details</span>
    </button>
  </div>
</template>
<script>
import dayjs from '@/lib/dayjs'

export default {
  props: {
    item: null,
    cruiseData: null,
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      showButton: false,
    }
  },
  async mounted() {
    if (this.cruiseData && this.cruiseData.itinerary !== 'no cruise found') {
      let _daysToAdd = []
      this.showButton = true
      this.$emit('widgetyShowing', true)
      if (this.cruiseData && this.cruiseData.itinerary.length > 0) {
        this.cruiseData.itinerary.forEach((item, index) => {
          if (item.arrives_on === item.departs_on && index != 0) {
            item.showDep = false
          } else if (item.arrives_on === item.departs_on && index === 0) {
            item.showArr = false
          }
          if (index === this.cruiseData.itinerary.length - 1) {
            return
          }
if (item.day + 1 !== this.cruiseData.itinerary[index + 1].day) {
            let _daysCalc = this.cruiseData.itinerary[index + 1].day - 1 - item.day

            let i = 0
            while (i < _daysCalc) {
              i++
              _daysToAdd.push(item.day + i)
            }
      }
        })
    const _paddedArray = this.cruiseData.itinerary
        const _startDate = this.cruiseData.itinerary[0].departs_on
        _daysToAdd.forEach((item, index) => {
          _paddedArray.splice(item, 0, {
            day: item,
            name: 'Sailing day - enjoy the facilities on board.',
            showDep: false,
            showArr: false,
          })
        })
        _paddedArray.forEach((item, index) => {
          if (!item.arrives_on) {
            item.arrives_on = dayjs(_startDate)
              .add(index, 'days')
              .startOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          }
        })
        _paddedArray.sort((a, b) => (new Date(a.day) > new Date(b.day) ? 1 : -1))
        this.item.showP4notes = false
      }
    } else if (this.item.p4text && this.item.p4text.length) {
      this.showButton = true
    }
  },
  methods: {
    show() {
      this.$refs['widgety-trip-info-modal-ref'].show()
    },
    formatDates(_date) {
      if (_date.includes('00:00:00')) {
        return dayjs(_date).format('ddd, MMM Do YYYY')
      } else {
        return dayjs(_date).format('ddd, MMM Do YYYY, h:mm a')
      }
    },
  },
}
</script>

<style scoped>
.modal-banner-container {
  position: relative;
  text-align: center;
  color: white;
  height: 30rem;
  overflow: hidden;
}

.modal-banner-text {
  font-size: 3vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.itinerary-container {
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.inclusion-container {
  background-color: #dbdbdb;
  margin: 10px;
  padding: 10px;
}

.address {
  text-indent: 40px;
}

.image-size {
  height: 55vh;
}

.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.vtd-font-weight-bold {
  font-weight: bolder;
}

.orange {
  color: orange;
  font-weight: bolder;
}
</style>
